<template>
  <div>
    <button
      v-if="!published"
      key="publish"
      :disabled="loading"
      class="btn btn-success w-full"
      @click="doPublish"
    >
      Publish
    </button>
    <button
      v-else
      key="unpublish"
      :disabled="loading"
      class="btn btn-danger w-full"
      @click="doUnpublish"
    >
      Unpublish
    </button>
  </div>
</template>

<script>
import { productMethods } from '@/store/adminHelper';

export default {
  name: 'PublishUnpublish',

  props: {
    productId: {
      type: String,
      required: true,
    },
    published: Boolean,
  },
  data: () => ({
    loading: false,
  }),
  methods: {
    ...productMethods,
    doPublish() {
      this.loading = true;
      this.publishProduct({ formData: { productId: this.productId } })
        .then(() => {
          this.loading = false;
          this.$emit('changed');
        })
        .catch(() => {
          this.loading = false;
        });
    },
    doUnpublish() {
      this.loading = true;
      this.unpublishProduct({ productId: this.productId })
        .then(() => {
          this.loading = false;
          this.$emit('changed');
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
